import React from 'react';
import { useParams } from 'react-router-dom';

const NovoPedido = () => {
  const { estabelecimentoId } = useParams();

  return (
    <div>
      <h2>Novo Pedido</h2>
      <p>Estabelecimento: {estabelecimentoId}</p>
      {/* Implementar formulário de pedido */}
    </div>
  );
};

export default NovoPedido;

